import type { TitleDetail } from '@/interfaces/title-details-graphql';

type TitleOffer = TitleDetail['offers'][number];

interface PromotedOfferOverrideConfig {
	titleId: string;
	countries: string[];
	providerShortName: string;
}

// Per-title overrides to force a specific provider's offer to the front of promotedOffers.
// Request for SR campaign
const PROMOTED_OFFER_OVERRIDE_CONFIGS: PromotedOfferOverrideConfig[] = [
	{
		titleId: 'tm1436931',
		countries: ['US'],
		providerShortName: 'stz',
	},
];

export function getPromotedOffersWithOverride(
	title: TitleDetail | null | undefined,
	country: string,
	promotedOffers: TitleOffer[]
): TitleOffer[] {
	if (!title) return promotedOffers;

	const config = PROMOTED_OFFER_OVERRIDE_CONFIGS.find(c => c.titleId === title.id && c.countries.includes(country));
	if (!config) return promotedOffers;

	const isPromoted = promotedOffers.some(o => o.package.shortName === config.providerShortName);
	if (isPromoted) {
		// already promoted, just move it to the front
		const rank = (o: TitleOffer) => (o.package.shortName === config.providerShortName ? -1 : 0);

		return [...promotedOffers].sort((a, b) => rank(a) - rank(b));
	}

	const offer = title.offers.find(o => o.package.shortName === config.providerShortName);

	if (!offer) return promotedOffers;

	return [offer, ...promotedOffers].slice(0, 2);
}
